export const CHUNK_SIZE = 64 * 1024; // 64KB
export const MAX_BUFFER_SIZE = 1024 * 1024; // 1MB
export const SPEED_SAMPLE_INTERVAL = 500; // ms
export const TOAST_DURATION = 4000; // ms
export const RECONNECT_INTERVAL = 3000; // ms
export const MAX_RECONNECT_ATTEMPTS = 10;
export const DEVICE_ID_KEY = 'localdrop-device-id';
export const DEVICE_NAME_KEY = 'localdrop-device-name';
export const THEME_KEY = 'localdrop-theme';
export const DEVICE_AVATAR_KEY = 'localdrop-device-avatar';

export const AVATAR_LIST = {
  female: {
    one: 'https://res.cloudinary.com/djftsbsuu/image/upload/v1782120125/female_one_kovlkz.png',
    two: 'https://res.cloudinary.com/djftsbsuu/image/upload/v1782120125/female_two_ttbjn8.png',
    three: 'https://res.cloudinary.com/djftsbsuu/image/upload/v1782120125/female_three_jkw6mb.png',
  },
  male: {
    one: 'https://res.cloudinary.com/djftsbsuu/image/upload/v1782120125/male_one_imn8ct.png',
    two: 'https://res.cloudinary.com/djftsbsuu/image/upload/v1782120125/male_two_h6jdvb.png',
    three: 'https://res.cloudinary.com/djftsbsuu/image/upload/v1782120125/male_three_bfensg.png',
  },
  device: {
    one: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/ipad-four_prg7zr.png",
    two: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/mac-mini_vzsspc.png",
    three: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/desktop-one_gkqe8t.png",
    four: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/laptop-one_tujhhs.png",
    five: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/laptop-two_tg4zaw.png",
    six: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/ipad-one_yatazv.png",
    seven: "https://res.cloudinary.com/djftsbsuu/image/upload/v1782127255/ipad-three_jof5o4.png"

  }
};

